// Components==============
import Button from 'components/UI/Button/Button';
import { motion } from 'framer-motion';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { useHistory } from 'react-router';
import { TranslateType } from 'typings';
import { framerFade } from 'utilities/FramerAnimations';
import Modal from '../Modal/Modal';
import './NavigationBlock.module.scss';
// =========================

export default function NavigationBlock({
  message,
  nextLocation,
  unblock,
  saveFunction,
  showSave,
}: {
  message: TranslateType;
  nextLocation: string;
  unblock: () => void;
  saveFunction?: () => void;
  showSave?: boolean;
}) {
  const translate = useTranslate();

  const history = useHistory();
  const { closeModal } = useRootModal();

  function handleSave() {
    saveFunction!();
    closeModal();
  }

  function handleConfirm() {
    unblock();
    history.push(nextLocation);
    closeModal();
  }

  function handleDeny() {
    closeModal();
  }

  return (
    <Modal size="medium">
      <motion.div styleName="wrapper" {...framerFade}>
        <h1>{translate('general.terms.be-aware')}</h1>
        <p>{message}</p>
        <div styleName="buttons">
          <Button onClick={handleDeny} color="grey">
            {translate('general.terms.cancel')}
          </Button>
          <Button onClick={handleConfirm}>
            {translate('general.terms.leave')}
          </Button>
          {saveFunction && showSave && (
            <Button onClick={handleSave} color="blue">
              {translate('general.terms.save-and-leave')}
            </Button>
          )}
        </div>
      </motion.div>
    </Modal>
  );
}
